<template lang="pug">
#coaches
  .main_container.container
    breadcrumb(v-bind:pageName="pageName")
    #accordion.mb-4
      .row
        coach-item(
          v-for="(coach, index) in coaches",
          :coach="coach",
          :key="index"
        )
  custom-footer
</template>

<script>
import CustomFooter from "@/components/common/Footer";
import Breadcrumb from "@/components/common/Breadcrumb";
import CoachItem from "@/components/coaches/CoachItem";
import { getCoachList } from "@/api/web_content";

export default {
  name: "TrainingEvents",
  components: {
    "custom-footer": CustomFooter,
    breadcrumb: Breadcrumb,
    "coach-item": CoachItem,
  },
  data() {
    return {
      pageName: "教練資訊",
      coaches: [],
    };
  },
  created() {
    this.getCoaches();
  },
  methods: {
    getCoaches() {
      getCoachList().then((response) => {
        this.coaches = response.data;
      });
    },
  },
};
</script>

<style scoped lang="scss">
#coaches {
  background-color: $color_bg_white;
}
</style>
